module.exports = __webpack_public_path__ + "124b0175073e279925f7275432ad384d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/PDF.png
// module id = zzXV
// module chunks = 17